import { createHttpClient } from '@aspid/api-client';

import { makeBaseUrl } from '@api/apiUtils/makeBaseUrl';
import { PUBLIC_URL } from '@constants';

/**
 * Транспорт приложения. Настройки (сессия, CSRF, сериализация массивов в
 * query) живут в `@aspid/api-client` и одинаковы для всех приложений —
 * приложение задаёт только свой базовый URL.
 */
export const HttpClientFactory = () =>
  createHttpClient({ baseURL: makeBaseUrl(PUBLIC_URL) });

export const HttpClient = HttpClientFactory();
